var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"login-form"},[_c('md-card-area',{staticClass:"d-flex direction-column mb-10"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._t("title")],2)]),_c('md-card-content',{staticClass:"md-layout md-alignment-center"},[_c('div',{staticClass:"h-100"},[_vm._t("form")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }